(function (global) {
    'use strict';

    // Получение высоты элемента по селектору
    function getBlockHeight(selector) {
        const el = document.querySelector(selector);
        return el ? el.offsetHeight : 0;
    }


    // Селекторы блоков для отслеживания
    const selectors = [
        '.dxbl-tabs-content.dxbl-active .eftr-block-of-filters',
        '.dxbl-tabs-tablist',
        '.header.d-flex.flex-row.shadow-sm.navbar-dark.flex-nowrap'
    ];

    // Обновление итоговой высоты
    function updateFinalHeights() {
        const totalBlocksHeight = selectors.reduce((sum, selector) =>
            sum + getBlockHeight(selector), 0);
        global.EffectiveHeight = window.innerHeight - totalBlocksHeight;
    }

    // Получение всех размеров
    function getDimensions() {
        const magicValue = 28;
        updateFinalHeights();
        return {
            Width: window.innerWidth,
            Height: window.innerHeight,
            EffectiveHeight: global.EffectiveHeight - magicValue
        };
    }

    /**
     * Класс для отслеживания появления элементов с CSS классом
     * и установки высоты другому элементу (использует MutationObserver)
     */
    class DomWatcher {
        mutationObserver = null;
        resizeObserver = null;
        className = null;
        elementToResizeSelector = null;

        /**
         * Запускает отслеживание всех элементов на странице
         * @param {string} className - CSS класс искомого элемента внутри элемента для изменения размера
         * @param {string} elementToResizeSelector - Селектор элемента, которому нужно установить min-height
         * @return {DomWatcher} Экземпляр для цепочки вызовов
         */
        startWatching(className, elementToResizeSelector) {
            if (!className || !elementToResizeSelector)
                return this;

            this.className = className;
            this.elementToResizeSelector = elementToResizeSelector;

            // Сразу обновляем высоту для всех существующих элементов
            this.updateAllHeights();

            // Отслеживаем изменения DOM (добавление/удаление элементов, изменение классов и стилей)
            this.mutationObserver = new MutationObserver(() => {
                this.updateAllHeights();
            });

            this.mutationObserver.observe(document.body, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class', 'style']
            });

            // Отслеживаем изменения размеров элементов
            this.resizeObserver = new ResizeObserver(() => {
                this.updateAllHeights();
            });

            // Добавляем все существующие элементы в ResizeObserver
            const elementsToResize = document.querySelectorAll(this.elementToResizeSelector);
            elementsToResize.forEach(element => {
                this.resizeObserver.observe(element);

                const targetElement = element.querySelector(`.${this.className}`) ||
                    element.getElementsByClassName(this.className)[0];
                if (targetElement) {
                    this.resizeObserver.observe(targetElement);
                }
            });

            return this;
        }

        /**
         * Обновляет высоту для всех элементов на странице
         */
        updateAllHeights() {
            // Находим ВСЕ элементы с указанным селектором на всей странице
            const elementsToResize = document.querySelectorAll(this.elementToResizeSelector);

            if (!elementsToResize || elementsToResize.length === 0) return;

            // Обрабатываем каждый найденный элемент
            elementsToResize.forEach(elementToResize => {
                // Ищем целевой элемент с нужным классом внутри элемента для изменения размера
                const targetElement = elementToResize.querySelector(`.${this.className}`) ||
                    elementToResize.getElementsByClassName(this.className)[0];

                if (targetElement) {
                    // Устанавливаем min-height на основе высоты целевого элемента
                    elementToResize.style.setProperty('min-height', `${targetElement.offsetHeight}px`, 'important');
                }
            });

            // Добавляем новые элементы в ResizeObserver
            if (this.resizeObserver) {
                elementsToResize.forEach(element => {
                    this.resizeObserver.observe(element);

                    const targetElement = element.querySelector(`.${this.className}`) ||
                        element.getElementsByClassName(this.className)[0];
                    if (targetElement) {
                        this.resizeObserver.observe(targetElement);
                    }
                });
            }
        }

        /**
         * Останавливает отслеживание
         * @return {DomWatcher} Экземпляр для цепочки вызовов
         */
        stopWatching() {
            if (this.mutationObserver) {
                this.mutationObserver.disconnect();
                this.mutationObserver = null;
            }

            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }

            return this;
        }
    }

    // Глобальный объект для взаимодействия с C#
    global.DomWatcherInterop = {
        watcher: null,

        initWatcher: function () {
            this.watcher = new DomWatcher();
            return true;
        },

        startWatching: function (className, elementToResizeSelector) {
            if (!this.watcher) {
                this.initWatcher();
            }
            this.watcher.startWatching(className, elementToResizeSelector);
            return true;
        },

        stopWatching: function () {
            if (this.watcher) {
                this.watcher.stopWatching();
                return true;
            }
            return false;
        }
    };

    // Экспорт функции получения размеров
    global.getDimensions = getDimensions;

})(window);